import React, { Dispatch, useEffect, useState } from 'react';

import _ from 'lodash';

import GradesTableGradeCell from 'clean/components/GradesTableGradeCell/GradesTableGradeCell';

const TableRow: React.FC<{
  student;
  subject;
  dates;
  marks;
  popoverOpened: string;
  setPopoverOpened: Dispatch<React.SetStateAction<string>>;
}> = ({ student, subject, dates, marks, popoverOpened, setPopoverOpened }) => {
  const [data, setSetData] = useState([]);
  const [average, setAverage] = useState(0);

  function formatDataToDisplay() {
    setAverage(
      _.sumBy(data, function (obj) {
        if (!obj.grade) {
          return 0;
        }
        return obj.grade?.mark?.value;
      }) /
        data.filter(obj => {
          return obj.grade?.mark;
        }).length ?? 1
    );
  }

  useEffect(() => {
    formatDataToDisplay();
  }, [data]);

  useEffect(() => {
    const grades = [];
    Object.keys(dates).forEach(function (str) {
      const grade = dates[str].filter(obj => {
        return obj.student.user?.full_name?.trim() === student.trim();
      })[0];
      grades.push({ grade, key: str + student });
    });

    setSetData(grades);
  }, [dates]);

  const updateGradesDate = (value, index) => {
    const dataCopy = JSON.parse(JSON.stringify(data));
    dataCopy[index].grade.mark = value.mark;

    setSetData(dataCopy);
  };

  return (
    <tr key={student + subject}>
      <td>{student}</td>
      {data.map((obj, index) => {
        return (
          <GradesTableGradeCell
            popoverOpened={popoverOpened}
            marks={marks}
            updateGradesData={value => updateGradesDate(value, index)}
            setPopoverOpened={setPopoverOpened}
            key={obj.key}
            grade={obj.grade}
            id={obj.key}
          />
        );
      })}

      <td key={average}>{Math.ceil(Number.isNaN(average) ? 0 : average)}</td>
    </tr>
  );
};

export default TableRow;
